export default __webpack_public_path__ + "static/media/plugin.5ecd4998.svg";